import { useAccountStore } from '@/store/account';
import { useInstances } from '@/hooks/use-instances';
import { apis, clearApis } from './track-api';
import { formatTime } from '@toy/utils';
// import { logTrajectory } from '@/api/track';
// import { SSO_SYSTEM_CODE } from '@/constant';
import { useMenuStore } from '@/store/menu';
import { currentEnv, ENV_ENUM } from '@/core/http/env';

const { getVueRouterInstance } = useInstances();
const router = getVueRouterInstance();

const STORAGE_KEY = 'track';

type TrackData = {
  url: string;
  startTime: string;
  endTime: string;
  userId: string;
  routerName: string;
  activeMenu: string;
};

const getTrackData = () => {
  const data = localStorage.getItem(STORAGE_KEY);
  const track = {
    url: '',
    startTime: '',
    userId: '',
    endTime: '',
    routerName: '',
    activeMenu: ''
  };
  if (!data) {
    return track;
  }
  try {
    Object.assign(track, JSON.parse(data));
  } catch (error) {
    console.log(error);
  }
  return track;
};

const saveLocalStorage = (data: TrackData) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

const trackData: TrackData = getTrackData();

export const sendTrackData = async () => {
  const accountStore = useAccountStore();
  const { account } = accountStore;
  if (trackData.userId && account?.id !== trackData.userId) return;
  const endTime = formatTime(new Date());
  trackData.endTime = endTime;
  const { getMenu } = useMenuStore();
  // console.log('current', router.currentRoute.value);
  const menuItem = getMenu(trackData.activeMenu || trackData.routerName);
  if (!menuItem) return;
  try {
    // await logTrajectory({
    //   menus: [{
    //     menuId: menuItem?.id || '',
    //     menuName: menuItem?.name || '',
    //     menuRouter: trackData.routerName,
    //   }],
    //   requestUrl: trackData.url,
    //   enterTime: trackData.startTime,
    //   quitTime: trackData.endTime,
    //   systemCode: SSO_SYSTEM_CODE,
    //   apis,
    // });
  } catch (error) {
    console.log(error);
  }
};

// router.beforeEach((to, from) => {
//   const isBeforeToLogin = to.fullPath.includes('login');
//   const accountStore = useAccountStore();
//   const { account } = accountStore;
//   if (isBeforeToLogin) {
//     saveLocalStorage({ ...trackData, url: from.fullPath, userId: account?.userId || '' });
//   } else {
//     clearApis();
//   }
// });

export const initTrackData = () => {
  const accountStore = useAccountStore();
  const { account } = accountStore;
  // console.log('router.currentRoute.value.name', router.currentRoute.value);
  trackData.userId = account?.account?.id || '';
  trackData.url = `/${document.location.hash}`;
  trackData.activeMenu = router.currentRoute.value.meta.activeMenu as string || '';
  trackData.startTime = formatTime(new Date());
  trackData.endTime = '';
  trackData.routerName = router.currentRoute.value.name as string || '';
  clearApis();
  saveLocalStorage(trackData);
};

const init = () => {
  if (currentEnv === ENV_ENUM.UAT) return;
  router.afterEach(async (to) => {
    const isOnLogin = document.location.href.includes('login');
    if (isOnLogin) {
      const track = getTrackData();
      if (track.url) {
        track.endTime = new Date().toLocaleString();
        saveLocalStorage(track);
      }
    } else {
      if (trackData.url) {
        // console.log('trackData', trackData);
        // console.log('apis', apis);
        await sendTrackData();
      }
      initTrackData();
      // console.log('trackData', trackData);
    }
  });
  document.addEventListener('visibilitychange', async () => {
    if (document.visibilityState === 'hidden') {
      if (trackData.url) {
        const endTime = formatTime(new Date());
        trackData.endTime = endTime;
        // console.log('trackData', trackData);
        // console.log('apis', apis);
        await sendTrackData();
        initTrackData();
      }
    } else {
      initTrackData();
    }
  });
};

init();
